import React, { memo, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import { DATE_FORMAT_DEFAULT, TYPE_STATUS } from '../../utils/constants'
import { EmptyText } from '../../components/common/CellText'
import { useLocation, useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { getNameInCapitalize, TextWrap } from '../../utils/common'
import { StatusTag } from '../../components/common/StatusTag'
import SkeletonTable from '../../components/Skeleton/SkeletonTable'
import EmptyData from '../../components/image/EmptyData'
import UnreadText from '../../components/common/UnreadText'
import ContentModal from '../../components/dialog/ContentModal'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Spin } from 'antd'
import { Button, useTheme } from '@mui/material'
import { AiOutlineFieldTime, AiOutlineSearch } from 'react-icons/ai'
import { HiOutlineDocumentText } from 'react-icons/hi2'
import NumbersIcon from '@mui/icons-material/Numbers'
import PopupCreateSignDoc from './PopupCreateSignDoc'
import AdvancedFilter from './AdvancedFilter'

const checkUnread = record => record?.status_internal_incoming !== 'READ'
const renderAuthorityIssuedName = (name, isText = false) => {
  if (name.authority_issued_name) {
    return name.authority_issued_name
  }
  if (name.other_authority_issued) {
    return (
      (isText && name.other_authority_issued) || (
        <span>{name.other_authority_issued}</span>
      )
    )
  }
  return ''
}

function createData(
  incoming_number,
  document_number,
  incoming_date,
  date_issued,
  document_status,
  title,
  record,
  handler,
  code
) {
  return {
    incoming_number,
    document_number,
    incoming_date,
    date_issued,
    document_status,
    title,
    record,
    handler,
    code,
  }
}

const InternalDocumentSign = props => {
  const {
    electronicDocumentStore,
    createMessage,
    openAdvancedFilter,
    setOpenAdvancedFilter,
  } = props

  const {
    electronicDocumentList,
    totalCount,
    queryParamsSignDocument,
    getElectronicDocumentList,
  } = electronicDocumentStore
  const location = useLocation()
  const navigate = useNavigate()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    title: null,
    from_incoming_date: null,
    to_incoming_date: null,
    value: null,
  })
  const [loading, setLoading] = useState(true)
  const [openContent, setOpenContent] = useState(false)
  const [isView, setIsView] = useState(false)
  const [isVisiblePopupCreateSignDoc, setIsVisiblePopupCreateSignDoc] =
    useState(false)
  const theme = useTheme()
  const NGAY_VAN_BAN_WIDTH = 100
  const CO_QUAN_BAN_HANH_WIDTH = 200
  const LANH_DAO_WIDTH = 150
  const SO_DEN_WIDTH = 100
  const [rows, setRows] = useState([])
  const [check, setCheck] = useState(false)
  const [checkV2, setCheckV2] = useState(false)
  useEffect(() => {
    const param = {
      page: queryStringParse.page || filter.page,
      size: queryStringParse.size || filter.size,
      title: queryStringParse.title || filter.title,
      from_date: queryStringParse.from_date || filter.from_date,
      to_date: queryStringParse.to_date || filter.to_date,
      status: queryStringParse.status || filter.status,
    }
    setFilter(param)
    ;(async () => {
      setLoading(true)
      electronicDocumentStore.clearElectronicDocumentList()
      electronicDocumentStore.clearFilter()
      await getElectronicDocumentList(param)
      setIsRefreshPage(false)
      setLoading(false)
    })()
  }, [])

  useEffect(() => {
    if (isRefreshPage) return
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    })
    navigate({
      pathname: '/internal-document/sign-document',
      search: queryStringStringify,
    })
    ;(async () => {
      try {
        setLoading(true)
        electronicDocumentStore.clearElectronicDocumentList()
        electronicDocumentStore.clearFilter()
        await getElectronicDocumentList(filter)
        setLoading(false)
      } catch (err) {
        // console.log(err)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])
  // console.log(JSON.stringify(electronicDocumentList))
  useEffect(() => {
    setRows(
      electronicDocumentList.map(record =>
        createData(
          <UnreadText
            text={record?.incoming_number}
            isUnread={checkUnread(record)}
            width={SO_DEN_WIDTH}
          />,
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <HiOutlineDocumentText size={20} color={theme.color.primary} />
                <div
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    color: theme.color.primary,
                  }}>
                  {record?.document_number}
                </div>
              </div>
            }
            isUnread={checkUnread(record)}
            width={'100%'}
          />,
          <UnreadText
            text={
              <div style={{ fontSize: 13, color: theme.color.gray }}>
                {moment(record?.incoming_date).format(DATE_FORMAT_DEFAULT)}
              </div>
            }
            isUnread={checkUnread(record)}
            // width={NGAY_DEN_WIDTH}
          />,
          record?.date_issued ? (
            <UnreadText
              style={{ fontSize: 14 }}
              text={moment(record?.date_issued).format(DATE_FORMAT_DEFAULT)}
              isUnread={checkUnread(record)}
              width={NGAY_VAN_BAN_WIDTH}
            />
          ) : (
            <TextWrap style={{ fontSize: 12 }}>
              <EmptyText>-----------------</EmptyText>
            </TextWrap>
          ),
          StatusTag(TYPE_STATUS.ELECTRONIC_DOCUMENT, record?.status),
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%',
              lineHeight: '25px',
              WebkitLineClamp: '2',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              maxHeight: '50px',
              padding: '4px',
            }}>
            {record?.title}
          </div>,

          record?.handler ? (
            <UnreadText
              text={getNameInCapitalize(record?.handler)}
              isUnread={checkUnread(record)}
              width={LANH_DAO_WIDTH}
            />
          ) : (
            <TextWrap>
              <EmptyText>-----------------</EmptyText>
            </TextWrap>
          ),
          record?.code
        )
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [electronicDocumentList])

  const [hasMore, setHasMore] = useState(false)
  const [infiniteLoading, setInfiniteLoading] = useState(false)
  const fetchMoreData = async () => {
    if (electronicDocumentList.length >= totalCount) {
      setHasMore(false)
      return
    }

    setInfiniteLoading(true)
    try {
      electronicDocumentStore.incrementPage()
      await electronicDocumentStore.getElectronicDocumentList({
        ...filter,
        page: electronicDocumentStore.queryParamsSignDocument.page,
        size: 10,
      })
      setHasMore(electronicDocumentList.length < totalCount)
    } catch (err) {
      // console.error(err)
    } finally {
      setInfiniteLoading(false)
    }
  }

  useEffect(() => {
    electronicDocumentStore.clearQueryParamsIncoming()
  }, [check, checkV2])

  useEffect(() => {
    if (electronicDocumentList.length <= totalCount) {
      setHasMore(true)
      return
    }
  }, [check, checkV2])
  const [value, setValue] = useState('')
  const handleQuickSearch = async event => {
    electronicDocumentStore.clearElectronicDocumentList()
    electronicDocumentStore.clearFilter()
    event.preventDefault()
    try {
      setLoading(true)
      await electronicDocumentStore.getElectronicDocumentList({
        ...filter,
        title: value,
      })
      setLoading(false)
    } catch (err) {
      // console.log(err)
    }
  }
  useEffect(() => {
    if (electronicDocumentList.length < totalCount) {
      setHasMore(true)
    } else {
      setHasMore(false)
    }
  }, [electronicDocumentList.length, totalCount])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [openCreateIncomingDoc, setOpenCreateIncomingDoc] = useState(false)

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: '10px', textTransform: 'none' }}
        onClick={() => {
          setIsVisiblePopupCreateSignDoc(true)
        }}>
        Tạo trình ký
      </Button>
      <form onSubmit={e => handleQuickSearch(e)}>
        <div
          className="mt-2 px-5 py-3 rounded-xl w-full  focus-visible:outline-none"
          style={{
            display: 'flex',
            alignItems: 'center',
            background: theme.background.light,
          }}>
          <AiOutlineSearch color="#65696e" fontSize={25} />
          <input
            className="py-1 rounded-xl w-full  focus-visible:outline-none"
            type="text"
            placeholder="Tìm kiếm"
            style={{ background: theme.background.light }}
            value={filter.value}
            onChange={e => {
              setValue(e.target.value.trim())
            }}
          />
        </div>
      </form>
      {loading ? (
        <SkeletonTable />
      ) : electronicDocumentList?.length > 0 ? (
        <section className="mt-1 pb-[30px] overflow-x-auto hideScrollbar">
          <InfiniteScroll
            dataLength={electronicDocumentList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            scrollThreshold={0.8}
            loader={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                }}>
                {infiniteLoading && <Spin tip="Đang tải..." />}{' '}
              </div>
            }>
            <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
              <div>
                {rows.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      navigate(
                        `/internal-document/sign-document/view/${row.handler}`
                      )
                    }}
                    style={{
                      backgroundColor: theme.background.light,
                      padding: '5px',
                      margin: '10px 0px',
                      borderRadius: '10px',
                      boxShadow: theme.boxShadow.boxShadow1,
                      position: 'relative',
                    }}>
                    <div className="flex justify-between items-center">
                      <div
                        className="pt-1"
                        style={{ width: 'calc(100% - 96px)' }}>
                        {row.document_number}
                      </div>
                      <div className="flex items-center">
                        <div style={{ paddingRight: 3 }}>
                          <AiOutlineFieldTime
                            size={16}
                            color={theme.color.gray}
                          />
                        </div>
                        <div style={{ width: '75px' }}>{row.incoming_date}</div>
                      </div>
                    </div>
                    <div className="mr-1 w-[100%]">{row.title}</div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 2,
                      }}>
                      <div
                        style={{
                          order: 0,
                          color: 'rgb(44, 101, 172)',
                          paddingLeft: '5px',
                        }}>
                        {row.incoming_number}
                      </div>
                      <div style={{ order: 1 }}>{row.document_status}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </section>
      ) : (
        <EmptyData />
      )}
      <ContentModal
        open={openContent}
        handleClose={() => {
          setOpenContent(false)
        }}
        // content={workSelect?.title}
        headerTitle="Văn bản đến"
      />
      <PopupCreateSignDoc
        filter={filter}
        isVisiblePopupCreateSignDoc={isVisiblePopupCreateSignDoc}
        handleClosePopupCreateSignDoc={() =>
          setIsVisiblePopupCreateSignDoc(false)
        }
      />
      <AdvancedFilter
        openAdvancedFilter={openAdvancedFilter}
        handleOpenAdvancedFilter={() => {
          setOpenAdvancedFilter(true)
        }}
        handleCloseAdvancedFilter={() => {
          setOpenAdvancedFilter(false)
        }}
        filter={filter}
        setFilter={setFilter}
        checkV2={checkV2}
        setCheckV2={setCheckV2}
      />
    </>
  )
}

export default memo(
  inject('electronicDocumentStore')(observer(InternalDocumentSign))
)
